export default {
  title: "light",

  colors: {
    primary: "#c62e65",
    secundary: "#2B303A",

    background: "#f5f5f5",
    text: "#333",
    button:"#c62e65",
    input: "rgba(0, 0, 0, 0.1)"
  }
};
